export const doesUserHaveScope = (
  scopeOrScopes: IUserScope | IUserScope[],
  scopes?: IUserScope[],
  strict: boolean = true,
) => {
  if (!scopes) return false;

  if (typeof scopeOrScopes === "string") {
    return scopes.includes(scopeOrScopes);
  } else {
    if (strict) return scopeOrScopes.every(scope => scopes.includes(scope));

    return !!scopes.find(scope => scopeOrScopes.includes(scope));
  }
};
